<div class="pop-up">
  <div class="wrap-top-parent">
    <div class="wrap-top">
      <div class="icon" id="iconContainer" (click)="onClose()">
        <img class="iconssolidx" alt="" src="assets/icons/x-icon.svg" />
      </div>
    </div>
    <div class="frame-parent">
      <div class="title-wrapper">
        <div class="title">
          <div class="wash-title">{{ "wash" | translate }}</div>
        </div>
      </div>
      <div class="lorem-ipsum-dolor">
        {{ "post-service-wash" | translate }}
      </div>
    </div>
  </div>
  <div class="toppings-wrap">
    <div class="wash-card-with-label">
      <div class="frame-group">
        <div class="input-label-wrapper">
          <div class="wash-input-label">
            {{ "select-wash-type" | translate }}
          </div>
        </div>
        <div class="badge">
          <div class="text">{{ "mandatory" | translate }}</div>
        </div>
      </div>
      <div
        class="wash-card-select"
        id="washCardSelect"
        *ngFor="let product of specializedCenterWashProducts"
        (click)="handleProductSelection(product)"
      >
        <div class="img-topping">
          <img class="services-icons" alt="" [src]="product.icon" />
        </div>
        <div class="wrap">
          <div class="text-and-selector">
            <div class="wash-title2">
              <div class="wash-title3">{{ product.titleId | translate }}</div>
              <div class="pricing">
                <div class="price">
                  <div class="read-more">{{ product.price }}€</div>
                </div>
              </div>
            </div>
            <div class="radio-button-3-wrapper">
              <div class="price">
                <div
                  class="radio-button"
                  [class.active]="selectedProductKey === product.titleId"
                ></div>
              </div>
            </div>
          </div>
          <div class="link-details-and-price">
            <div class="details">
              <div class="read-more">{{ "what-is-included" | translate }}</div>
              <div class="icon1">
                <img
                  class="iconssolidchevron-right"
                  alt=""
                  src="assets/icons/chevron-right-blue.svg"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer-extras">
  <button
    class="buttons-2"
    [disabled]="!selectedProductKey"
    (click)="addTopping()"
  >
    {{ "add" | translate }}
  </button>
</div>
